import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

export const grid: CSSObject = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(184px, 1fr))',
  gap: 16,
  marginBottom: 40,
  [mobile]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 12,
  },
};

export const itemWrap: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  padding: '12px 12px 16px',
  background: color.white,
  borderRadius: radius.xl,
};

export const thumbnail: CSSObject = {
  position: 'relative',
  width: '100%',
  aspectRatio: '1 / 1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: color.grey75,
  borderRadius: radius.lg,
  overflow: 'hidden',
  userSelect: 'none',
  img: {
    width: '75%',
    height: '75%',
    objectFit: 'contain',
  },
};

export const disabledCover: CSSObject = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(12, 12, 12, 0.85)',
  color: color.white,
  fontSize: 14,
  fontWeight: 700,
};

export const info: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 4,
  marginTop: 12,
  '> div': { minWidth: 0 },
};

export const name: CSSObject = {
  fontSize: 15,
  fontWeight: 700,
  color: color.text,
  userSelect: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const description: CSSObject = {
  marginTop: 4,
  fontSize: 13,
  lineHeight: 1.4,
  color: color.textMuted,
  userSelect: 'none',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const moreButton: CSSObject = {
  flex: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  marginRight: -6,
  borderRadius: radius.sm,
  color: color.grey500,
  cursor: 'pointer',
  ':hover': { background: color.grey75, color: color.text },
};

export const menu: CSSObject = {
  minWidth: 140,
  padding: 6,
  background: color.white,
  border: `1px solid ${color.grey100}`,
  borderRadius: radius.md,
  boxShadow: theme.shadow.popover,
  zIndex: 1,
  '> ul > li': {
    padding: '10px 12px',
    borderRadius: radius.sm,
    fontSize: 14,
    color: color.text,
    cursor: 'pointer',
    '&:hover': { background: color.grey50 },
  },
};
